'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _HeaderDropDown = require('./HeaderDropDown');

var _HeaderDropDown2 = _interopRequireDefault(_HeaderDropDown);

require('./LanguageSelector.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LanguageSelector = function (_PureComponent) {
  (0, _inherits3.default)(LanguageSelector, _PureComponent);

  function LanguageSelector() {
    (0, _classCallCheck3.default)(this, LanguageSelector);
    return (0, _possibleConstructorReturn3.default)(this, (LanguageSelector.__proto__ || (0, _getPrototypeOf2.default)(LanguageSelector)).apply(this, arguments));
  }

  (0, _createClass3.default)(LanguageSelector, [{
    key: 'changeLocale',
    value: function changeLocale(value) {
      this.props.onChange(value);
    }
  }, {
    key: 'createLanguagesList',
    value: function createLanguagesList() {
      var LanguagesList = [];
      var _props = this.props,
          languages = _props.languages,
          menuRowCount = _props.menuRowCount;

      var listCount = Math.ceil(languages.length / menuRowCount);

      for (var i = 0; i < listCount; i++) {
        var list = languages.slice(i * menuRowCount, (i + 1) * menuRowCount);
        LanguagesList.push({
          slice: i,
          list: list
        });
      }
      return LanguagesList;
    }
  }, {
    key: 'createMenuContent',
    value: function createMenuContent(languages, currentLocale) {
      var _this2 = this;

      var groupLanguages = this.createLanguagesList();

      var languageLists = groupLanguages.map(function (langList) {
        var list = langList.list.map(function (language) {
          return _react2.default.createElement(
            'li',
            { key: language.value },
            _react2.default.createElement(
              'a',
              { onClick: function onClick() {
                  return _this2.changeLocale(language);
                }, className: language.value === currentLocale ? 'selected' : '' },
              language.text
            )
          );
        });
        return _react2.default.createElement(
          'div',
          { className: 'language-list', key: langList.slice },
          list
        );
      });

      return _react2.default.createElement(
        'div',
        { className: 'multiple-language-lists row row-justify-space-between' },
        languageLists
      );
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          languageItemClass = _props2.languageItemClass,
          iconItemClass = _props2.iconItemClass,
          currentLocale = _props2.currentLocale,
          hasUser = _props2.hasUser,
          languages = _props2.languages,
          menuGroupClass = _props2.menuGroupClass;

      var currentLanguage = languages.find(function (language) {
        return language.value === currentLocale;
      });
      var menuContainerClass = hasUser ? 'language-list-menu' : 'language-list-menu last-menu';

      var menuContent = this.createMenuContent(languages, currentLocale);

      var headerDropDownItemClass = (0, _classnames2.default)('language-item', languageItemClass);

      var icon = (0, _classnames2.default)('icon-world', iconItemClass);

      return _react2.default.createElement(
        _HeaderDropDown2.default,
        {
          icon: icon,
          menuContainerClass: menuContainerClass,
          headerDropDownItemClass: headerDropDownItemClass,
          subMenuGroupClass: menuGroupClass,
          menuContent: menuContent },
        currentLanguage.text
      );
    }
  }]);
  return LanguageSelector;
}(_react.PureComponent);

LanguageSelector.defaultProps = {
  menuRowCount: 10
};

exports.default = LanguageSelector;